import HttpAbstract from './http';
import postSerializer from './serializer';
/**
 * Serialize data, adds default config and transfer to code http module
 *
 */
class PostSerializedHttpAbstract extends HttpAbstract {
    post(...[url, data, opts]) {
        return super.post(url, postSerializer(data), opts);
    }
}
/**
 * Prepend endpoint address to url, and support passing data to
 * querystring when method is GET.
 */
export default class EndpointAbstract extends PostSerializedHttpAbstract {
    constructor(baseUrl) {
        super();
        this.baseUrl = baseUrl;
    }
    request(method, url, ...args) {
        url = url.includes('://') ? url : this.baseUrl + url;
        return super.request(method, url, ...args);
    }
}
//# sourceMappingURL=endpoint.js.map